const AuthenticateUserResultTypes = Object.freeze({
  SUCCESS: 1,
  INVALID_USERNAME_OR_EMAIL_ADDRESS: 2,
  INVALID_PASSWORD: 3,
  USER_IS_NOT_ACTIVE: 4,
});

export default AuthenticateUserResultTypes;
